var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCockpit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3307_18932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3307_18932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 12.5417C9.25694 12.8472 9.65278 12.9896 10.125 12.9688C10.5972 12.9479 10.9444 12.7708 11.1667 12.4375L14.4375 7.58333C14.5486 7.41667 14.5312 7.26042 14.3854 7.11458C14.2396 6.96875 14.0833 6.95139 13.9167 7.0625L9.05998 10.3386C8.71444 10.5712 8.52778 10.9201 8.5 11.3854C8.47222 11.8507 8.61806 12.2361 8.9375 12.5417ZM10.0208 4C10.5486 4 11.0417 4.04514 11.5 4.13542C11.9583 4.22569 12.3886 4.34685 12.7908 4.4989C12.9858 4.56908 13.1076 4.69965 13.1562 4.89062C13.2049 5.0816 13.1736 5.26389 13.0625 5.4375C12.9375 5.61806 12.7743 5.73958 12.5729 5.80208C12.3715 5.86458 12.1696 5.8625 11.9673 5.79583C11.6696 5.69583 11.3611 5.62153 11.0417 5.57292C10.7222 5.52431 10.3854 5.5 10.0311 5.5C8.21869 5.5 6.67708 6.14931 5.40625 7.44792C4.13542 8.74653 3.5 10.2639 3.5 12C3.5 12.5278 3.53819 12.9618 3.61458 13.3021C3.69097 13.6424 3.8125 14.0417 3.97917 14.5H16C16.1806 14.0417 16.309 13.6215 16.3854 13.2396C16.4618 12.8576 16.5 12.4444 16.5 12C16.5 11.5556 16.4514 11.1007 16.3542 10.6354C16.2569 10.1701 16.1111 9.72917 15.9167 9.3125C15.8194 9.11806 15.7917 8.91667 15.8333 8.70833C15.875 8.5 15.9859 8.33035 16.1659 8.1994C16.3331 8.08035 16.5174 8.04514 16.7188 8.09375C16.9201 8.14236 17.0694 8.26389 17.1667 8.45833C17.4444 9 17.6528 9.56597 17.7917 10.1562C17.9306 10.7465 18 11.3472 18 11.9583C18 12.6667 17.941 13.2847 17.8229 13.8125C17.7049 14.3403 17.5139 14.8264 17.25 15.2708C17.1111 15.5069 16.934 15.6875 16.7188 15.8125C16.5035 15.9375 16.2639 16 16 16H4C3.73611 16 3.49653 15.9375 3.28125 15.8125C3.06597 15.6875 2.88889 15.5069 2.75 15.2708C2.48611 14.8264 2.29514 14.3403 2.17708 13.8125C2.05903 13.2847 2 12.6667 2 11.9583C2 10.8511 2.21181 9.81382 2.63542 8.84663C3.05903 7.87943 3.63194 7.03819 4.35417 6.32292C5.07639 5.60764 5.92666 5.04167 6.90498 4.625C7.88328 4.20833 8.9219 4 10.0208 4Z",
    fill: "#1A0063"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCockpit);
export default __webpack_public_path__ + "static/media/cockpit.b9ccc136e13e4c4e662e2dc88b1c7ad6.svg";
export { ForwardRef as ReactComponent };